import { useTRPC } from "@/trpc/client";
import { useQuery } from "@tanstack/react-query";

export function usePulseConfig(
  businessId: string | undefined,
  teamId?: string,
) {
  const trpc = useTRPC();
  return useQuery(
    trpc.intelligence.pulse.getConfig.queryOptions(
      {
        businessId: businessId ?? "",
        ...(teamId ? { teamId } : {}),
      },
      { enabled: Boolean(businessId) },
    ),
  );
}

export function usePulsePeriods(
  businessId: string | undefined,
  count = 6,
  teamId?: string,
) {
  const trpc = useTRPC();
  return useQuery(
    trpc.intelligence.pulse.listPeriods.queryOptions(
      {
        businessId: businessId ?? "",
        count,
        ...(teamId ? { teamId } : {}),
      },
      { enabled: Boolean(businessId) },
    ),
  );
}

export function usePulseScores(
  businessId: string | undefined,
  periodStart: string | undefined,
  periodEnd: string | undefined,
  teamId?: string,
) {
  const trpc = useTRPC();
  return useQuery(
    trpc.intelligence.pulse.listScoresForPeriod.queryOptions(
      {
        businessId: businessId ?? "",
        periodStart: periodStart ?? "",
        periodEnd: periodEnd ?? "",
        ...(teamId ? { teamId } : {}),
      },
      { enabled: Boolean(businessId && periodStart && periodEnd) },
    ),
  );
}

export function usePulseCompletion(
  businessId: string | undefined,
  periodStart?: string,
  periodEnd?: string,
  teamId?: string,
) {
  const trpc = useTRPC();
  return useQuery(
    trpc.intelligence.pulse.getCompletionSummary.queryOptions(
      {
        businessId: businessId ?? "",
        ...(periodStart && periodEnd ? { periodStart, periodEnd } : {}),
        ...(teamId ? { teamId } : {}),
      },
      { enabled: Boolean(businessId) },
    ),
  );
}

export function useMemberPulseHistory(
  businessId: string | undefined,
  memberId: string | undefined,
  limit = 12,
) {
  const trpc = useTRPC();
  return useQuery(
    trpc.intelligence.pulse.getMemberPulseHistory.queryOptions(
      { businessId: businessId ?? "", memberId: memberId ?? "", limit },
      { enabled: Boolean(businessId && memberId) },
    ),
  );
}

export function useTeamPulseSummary(
  businessId: string | undefined,
  teamId?: string,
  periodStart?: string,
  periodEnd?: string,
) {
  const trpc = useTRPC();
  return useQuery(
    trpc.intelligence.pulse.getTeamPulseSummary.queryOptions(
      {
        businessId: businessId ?? "",
        ...(teamId ? { teamId } : {}),
        ...(periodStart && periodEnd ? { periodStart, periodEnd } : {}),
      },
      { enabled: Boolean(businessId) },
    ),
  );
}
